import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, Button, notification } from "antd";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import dayjs from "dayjs";
const EventModal = ({
  isOpenEvent,
  setIsOpenEvent,
  hideModalOpenEvent,
  recordEvent,
  setIsTriggerEvent,
}) => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (recordEvent && isOpenEvent) {
      form.setFieldsValue({
        eventName: recordEvent.eventName,
        remark: recordEvent.remark,
        startDate: dayjs(recordEvent.meetStartDate, "DD/MM/YYYY HH:mm"),
        endDate: dayjs(recordEvent.meetEndDate, "DD/MM/YYYY HH:mm"),
      });
    }
  }, [isOpenEvent, recordEvent]);

  const openNotificationWithIcon = (type, message, description = "") => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        try {
          const data = {
            eventName: values.eventName,
            remark: values.remark,
            meetStartDate: dayjs(values.startDate).format("DD/MM/YYYY HH:mm"),
            meetEndDate: dayjs(values.endDate).format("DD/MM/YYYY HH:mm"),
            createAt: new Date(),
          };

          if (recordEvent?.id) {
            const docRef = doc(db, "meetings", recordEvent.id);
            await updateDoc(docRef, data);
            openNotificationWithIcon("success", "Updated successfully");
          } else {
            await addDoc(collection(db, "meetings"), data);
            openNotificationWithIcon("success", "Created successfully");
          }

          form.resetFields();
          setIsTriggerEvent((c) => !c);
          hideModalOpenEvent();
        } catch (error) {
          console.error("Error saving document: ", error);
          alert("Error saving meeting details.");
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    hideModalOpenEvent();
  };

  return (
    <div>
      {contextHolder}
      <Modal
        title="Create Event"
        open={isOpenEvent}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" name="eventForm">
          <Form.Item
            label="Event Name"
            name="eventName"
            rules={[
              { required: true, message: "Please input the event name!" },
            ]}
          >
            <Input placeholder="Enter event name" />
          </Form.Item>

          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[
              { required: true, message: "Please select the start date!" },
            ]}
          >
            <DatePicker
              showTime
              format={"DD/MM/YYYY HH:mm"}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: true, message: "Please select the end date!" }]}
          >
            <DatePicker
              showTime
              format={"DD/MM/YYYY HH:mm"}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item label="Remark" name="remark">
            <Input.TextArea
              rows={3}
              placeholder="Enter any remarks (optional)"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default EventModal;
